module.exports = {
    /*File Explorer Data - Start*/
    newFolderName: '',
    childFolderName: '',
    deletedFileName: '',
    deletedFolderName: '',
    permissionRoleName: 'abc',
    shareUserName: 'Moshe White',
    shareRoleName: 'abc',
    invalidShareRoleName: 'NewRole',
    searchFileName: 'IndividualList.pdf',
    /*File Explorer Data - End*/


    LockOpenIcon: 'LockOpenIcon',
    userName: 'userName',
    LockIcon: 'LockIcon',
    test6: 'test6',
    lockedOn: 'lockedOn',
    searchDate: '05/06/2025',
    FreshRole: 'FreshRole',
    roleName: 'roleName',
    testUser: 'testUser'
};